import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import Container from '../../../components/structure/Container'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import ServicesList from './ServicesList'

const SelectIntegrationServiceModal = props => {
  return (
    <ControlledModal fullScreen {...props}>
      <ModalHeader />

      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={4} />

      <Container maxWidth="68rem">
        <ServicesList />
      </Container>
    </ControlledModal>
  )
}

export default SelectIntegrationServiceModal
